import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationFavoriteProjectArgs, BackendProject } from 'src/types/backend';

const MUTATION = gql`
  mutation FavoriteProject($projectId: ID!, $favorite: Boolean!) {
    favoriteProject(projectId: $projectId, favorite: $favorite) {
      id
      favorite
    }
  }
`;

type Variables = BackendMutationFavoriteProjectArgs;
type Result = Pick<BackendProject, 'id' | 'favorite'>;

export const updateProjectFavorite = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
